import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31b57462"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid bg-dark bg-opacity-75 text-light vh-100 d-flex flex-column" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "row bg-dark" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-8 text-start" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Kubernetes Admin Service")
], -1))
const _hoisted_6 = { class: "col-4 text-end p-2" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row pt-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("label", { for: "tokenTextInput" }, "Token:")
  ])
], -1))
const _hoisted_10 = { class: "row pb-2" }
const _hoisted_11 = { class: "col-12" }
const _hoisted_12 = { class: "row pb-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "alert alert-danger",
    role: "alert"
  }, " Problem connecting to the API. Please check the specified token and try again. ")
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row pb-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
    /*#__PURE__*/_createElementVNode("input", {
      type: "submit",
      class: "btn-outline-success w-100",
      value: "Connect"
    })
  ])
], -1))
const _hoisted_16 = { class: "row bg-dark" }
const _hoisted_17 = { class: "col-12 text-center p-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ServiceMeta = _resolveComponent("ServiceMeta")!
  const _component_ServiceControl = _resolveComponent("ServiceControl")!
  const _component_ServiceLogs = _resolveComponent("ServiceLogs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.store.state.configuration.contactMail), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("form", {
              id: "tokenForm",
              onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.connect && _ctx.connect(...args)), ["prevent"]))
            }, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("input", {
                    id: "tokenTextInput",
                    type: "text",
                    minlength: "64",
                    maxlength: "64",
                    required: "",
                    pattern: "[a-zA-Z0-9]+",
                    class: "w-100",
                    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateToken && _ctx.updateToken(...args))),
                    placeholder: "Token..."
                  }, null, 32)
                ])
              ]),
              _withDirectives(_createElementVNode("div", _hoisted_12, _hoisted_14, 512), [
                [_vShow, _ctx.showConnectionErrorAlert]
              ]),
              _hoisted_15
            ], 32)
          ])
        ])
      ])
    ]),
    _withDirectives(_createVNode(_component_ServiceMeta, null, null, 512), [
      [_vShow, this.store.state.webSocket !== null]
    ]),
    _withDirectives(_createVNode(_component_ServiceControl, null, null, 512), [
      [_vShow, this.store.state.webSocket !== null]
    ]),
    _withDirectives(_createVNode(_component_ServiceLogs, { class: "flex-fill overflow-auto" }, null, 512), [
      [_vShow, this.store.state.webSocket !== null]
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.store.state.configuration.footer), 1)
    ])
  ]))
}